import axios from 'axios';
import store from '../store'
import router from "../router";

class PaymentsRepository {

    constructor(){
        this.basePath = store.state.backend;
    }

    allPayments() {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/payments`, {headers: headers});
        response.catch((error) => { if(error.response.status === 401) { store.commit('clearData'); router.push('/'); } });  // Go to login to re-authenticate
        return response;
    }

    allCoupons() {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/coupons`, {headers: headers});
        response.catch((error) => { if(error.response.status === 401) { store.commit('clearData'); router.push('/'); } });  // Go to login to re-authenticate
        return response;
    }

    createCoupon(coupon) {
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/coupons`, coupon, {headers: headers});
        response.catch((error) => { if(error.response.status === 401) { store.commit('clearData'); router.push('/'); } });  // Go to login to re-authenticate
        return response;
    }

    deleteCoupon(couponName) {
        let headers = {'Authorization': store.state.token};
        let response = axios.delete(`${this.basePath}/coupons/${couponName}`, {headers: headers});
        response.catch((error) => { if(error.response.status === 401) { store.commit('clearData'); router.push('/'); } });  // Go to login to re-authenticate
        return response;
    }
}

export default new PaymentsRepository();
